import { Blackbox } from "@common/models/blackbox";
import { Log } from "@common/models/eventTracking";
import { IssueMessageResponse } from "@common/models/issueTracking";
import ApiService from "@common/services/Api.service";
import { PublicIssue } from "@public/models/PublicIssue";
import { AxiosResponse } from "axios";

export class UserFeedbackService {
  private apiService: ApiService;

  constructor() {
    this.apiService = ApiService.getInstance();
  }

  getUserFeedback(issueId: string, abortSignal?: AbortSignal): Promise<AxiosResponse<PublicIssue>> {
    return this.apiService.instancePublic.get(`issue_tracking/issues/${issueId}`, {
      signal: abortSignal,
    });
  }

  getActivityHistory(issueId: string, abortSignal?: AbortSignal): Promise<AxiosResponse<Log>> {
    return this.apiService.instancePublic.get(`issue_tracking/issues/${issueId}/log`, {
      signal: abortSignal,
    });
  }

  downloadActivityHistory(issueId: string) {
    return this.apiService.instancePublic.get<BlobPart>(`issue_tracking/issues/${issueId}/log/download`, {
      responseType: "blob",
    });
  }

  getBlackbox(issueId: string) {
    return this.apiService.instancePublic.get<Blackbox>(`issue_tracking/issues/${issueId}/blackbox`);
  }

  getChat(issueId: string) {
    return this.apiService.instancePublic.get<IssueMessageResponse[]>(`issue_tracking/issues/${issueId}/chat`, {});
  }
}
